export default __webpack_public_path__ + "static/media/music.a1ea17fc.mp3";